module.exports = __webpack_public_path__ + "img/1.12e1de36.jpg";